<button mat-button [matMenuTriggerFor]="languageMenu" class="main-button">
  <span class="list-item2 justify-center">
    <img [src]="'assets/flags/' + $safeNavigationMigration(lang?.flag)">
  </span>
</button>

<mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
  @for (l of languages; track l) {
    <button class="list-item2" (click)="setLang(l)" mat-menu-item>
      <div class="flex items-center justify-between">
        <img [src]="'assets/flags/' + l.flag" class="mr-4">
        {{l.name}}
      </div>
    </button>
  }
</mat-menu>
